
import { PricePoliciesApiRemoteService } from '../../Services/api/price-policies/price-policies-service'
import { ICreatePricePoliciesPayload, ICreateRulesPoliciesPayload, IPricePoliciesEntity } from '../../Services/api/price-policies/price-policies.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class CreatePricePoliciesRulesUseCase
implements IFormUsecase<ICreateRulesPoliciesPayload, void> {
  constructor (private readonly PricePoliciesApi: PricePoliciesApiRemoteService) {}
    
  public async handle (
    data: ICreateRulesPoliciesPayload
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.PricePoliciesApi.createRules(data)

      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
